<h1 mat-dialog-title class="p-2 text-center ">Calibration conductivité</h1>
<div class="p-3 overflow-auto">
    <div *ngIf="model" class="col">
        <h3 class="text-center"> Contexte de l'ajustage </h3>
        <div class="row ">
            <mat-form-field class="col-6">
                <!-- <mat-label>Sampler Puid</mat-label> -->
                <input matInput placeholder="Sera remplit par votre PUID" [(ngModel)]="model.SamplerPuid" readonly>
            </mat-form-field>

            <mat-form-field class="col-6 col-md">
                <mat-label>Date </mat-label>
                <input matInput placeholder="Date " [matDatepicker]="picker" [(ngModel)]="model.Date" (focus)="picker.open()" [disabled]="!CanEditAjustage">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <!-- <mat-form-field class="col">
                <mat-label>Heure</mat-label>
                <input matInput placeholder="Heure" [ngxTimepicker]="timepicker" [value]="interventionTime" [format]="24" readonly>
                <ngx-material-timepicker #timepicker (timeSet)="timeSet($event)"></ngx-material-timepicker>
            </mat-form-field> -->
        </div>

        <div class="row align-items-center justify-content-center">
            <h5 class="col-12 col-md"> 1413µS/cm</h5>

            <mat-form-field class="col-12 col-md">
                <mat-label>Nro Lot</mat-label>
                <input matInput placeholder="Nro Lot" [(ngModel)]="Ajustage1413.NumeroLot" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Date ouverture</mat-label>
                <input matInput placeholder="Date " [matDatepicker]="picker2" [(ngModel)]="Ajustage1413.DateOuverture"
                       [disabled]="!CanEditAjustage" (focus)="picker2.open()">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Valeur Cible</mat-label>
                <input matInput type="number" placeholder="Valeur Cible" [(ngModel)]="Ajustage1413.ControleConductivite.ValeurCible" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Valeur Mesuree</mat-label>
                <input matInput type="number" placeholder="Valeur Mesuree" [(ngModel)]="Ajustage1413.ControleConductivite.ValeurMesuree" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <!-- (keyup)="checkConformiteA5pourcent(Ajustage1413.ControleConductivite.ValeurCible, Ajustage1413.ControleConductivite.ValeurMesuree)" -->
            <mat-form-field class="col-12 col-md">
                <mat-label>Temperature</mat-label>
                <input matInput type="number" placeholder="Temperature" [(ngModel)]="Ajustage1413.ControleConductivite.Temperature" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <!-- <mat-slide-toggle class="col-auto" [ngModel]="Ajustage1413.ControleConductivite.Conforme" [disabled]="!CanEditAjustage">Conforme</mat-slide-toggle> -->

            <div class="col-auto">
                <mat-icon style="color: darkgreen;" *ngIf="Ajustage1413.ControleConductivite.Conforme">task_alt</mat-icon>
                <mat-icon style="color: red;" *ngIf="!Ajustage1413.ControleConductivite.Conforme">task_alt</mat-icon>
            </div>
        </div>

        <div class="row align-items-center justify-content-center">
            <h5 class="col-12 col-md"> 84µS/cm</h5>

            <mat-form-field class="col-12 col-md">
                <mat-label>Nro Lot</mat-label>
                <input matInput placeholder="Nro Lot" [(ngModel)]="Ajustage84.NumeroLot" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Date ouverture</mat-label>
                <input matInput placeholder="Date " [matDatepicker]="picker3" [(ngModel)]="Ajustage84.DateOuverture"
                       (focus)="picker3.open()" [disabled]="!CanEditAjustage">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="col-12 col-md">
                <mat-label>Valeur Cible</mat-label>
                <input matInput type="number" placeholder="Valeur Cible" [(ngModel)]="Ajustage84.ControleConductivite.ValeurCible" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Valeur Mesuree</mat-label>
                <input matInput type="number" placeholder="Valeur Mesuree" [(ngModel)]="Ajustage84.ControleConductivite.ValeurMesuree" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Temperature</mat-label>
                <input matInput type="number" placeholder="Temperature" [(ngModel)]="Ajustage84.ControleConductivite.Temperature" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <!-- <mat-slide-toggle class="col-auto" [ngModel]="Ajustage84.ControleConductivite.Conforme" [disabled]="!CanEditAjustage">Conforme</mat-slide-toggle> -->

            <div class="col-auto">
                <mat-icon style="color: darkgreen;" *ngIf="Ajustage84.ControleConductivite.Conforme">task_alt</mat-icon>
                <mat-icon style="color: red;" *ngIf="!Ajustage84.ControleConductivite.Conforme">task_alt</mat-icon>
            </div>
        </div>

        <div class="row align-items-center justify-content-center">
            <h5 class="col"> 0µS/cm</h5>

            <div class="col"></div>
            <div class="col"></div>
            <mat-form-field class="col-12 col-md">
                <mat-label>Valeur Cible</mat-label>
                <input matInput type="number" placeholder="Valeur Cible" [(ngModel)]="Ajustage0.ControleConductivite.ValeurCible" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Valeur Mesuree</mat-label>
                <input matInput type="number" placeholder="Valeur Mesuree" [(ngModel)]="Ajustage0.ControleConductivite.ValeurMesuree" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Temperature</mat-label>
                <input matInput type="number" placeholder="Temperature" [(ngModel)]="Ajustage0.ControleConductivite.Temperature" [disabled]="!CanEditAjustage">
            </mat-form-field>
            <!-- <mat-slide-toggle class="col-auto" [ngModel]="Ajustage0.ControleConductivite.Conforme" [disabled]="!CanEditAjustage">Conforme</mat-slide-toggle> -->

            <div class="col-auto">
                <mat-icon style="color: darkgreen;" *ngIf="Ajustage0.ControleConductivite.Conforme">task_alt</mat-icon>
                <mat-icon style="color: red;" *ngIf="!Ajustage0.ControleConductivite.Conforme">task_alt</mat-icon>
            </div>
        </div>
        
        <span *ngIf="!CanEditAjustage">
            <h3 class="text-center"> Controle Conformite de fin de journée </h3>
            <div class="row ">

                <mat-form-field class="col-12 col-md">
                    <input matInput placeholder="Sera remplit par votre PUID" [(ngModel)]="group.SamplerPuid" readonly>
                </mat-form-field>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Date </mat-label>
                    <input matInput placeholder="Date " [matDatepicker]="picker1" [(ngModel)]="group.Date" (focus)="picker1.open()">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>

            </div>

            <div class="row align-items-center justify-content-center">
                <h5 class="col-12 col-md">Tampon 1413µS/cm</h5>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Valeur Mesurée</mat-label>
                    <input matInput type="number" placeholder="Valeur Mesurée" type="number" [(ngModel)]="group.C1413.ValeurMesuree">
                </mat-form-field>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Valeur Cible</mat-label>
                    <input matInput type="number" placeholder="Valeur Cible" type="number" [(ngModel)]="group.C1413.ValeurCible">
                </mat-form-field>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Temperature</mat-label>
                    <input matInput type="number" placeholder="Temperature" type="number" [(ngModel)]="group.C1413.Temperature">
                </mat-form-field>

                <!-- <mat-slide-toggle class="col-auto" [ngModel]="group.C1413.Conforme">Conforme</mat-slide-toggle> -->
                <div class="col-auto">
                    <mat-icon style="color: darkgreen;" *ngIf="group.C1413.Conforme">task_alt</mat-icon>
                    <mat-icon style="color: red;" *ngIf="!group.C1413.Conforme">task_alt</mat-icon>
                </div>
            </div>

            <div class="row align-items-center justify-content-center">
                <h5 class="col">Tampon 84µS/cm</h5>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Valeur Mesurée</mat-label>
                    <input matInput type="number" placeholder="Valeur Mesurée" type="number" [(ngModel)]="group.C84.ValeurMesuree">
                </mat-form-field>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Valeur Cible</mat-label>
                    <input matInput type="number" placeholder="Valeur Cible" type="number" [(ngModel)]="group.C84.ValeurCible">
                </mat-form-field>

                <mat-form-field class="col-12 col-md">
                    <mat-label>Temperature</mat-label>
                    <input matInput type="number" placeholder="Temperature" type="number" [(ngModel)]="group.C84.Temperature">
                </mat-form-field>

                <!-- <mat-slide-toggle class="col-auto" [ngModel]="group.C84.Conforme">Conforme</mat-slide-toggle> -->
                <div class="col-auto">
                    <mat-icon style="color: darkgreen;" *ngIf="group.C84.Conforme">task_alt</mat-icon>
                    <mat-icon style="color: red;" *ngIf="!group.C84.Conforme">task_alt</mat-icon>
                </div>

            </div>
        </span>

        <div class="row">
            <button class="col mx-1" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                Annuler<mat-icon>undo</mat-icon>
            </button>
 
            <button class="col mx-1" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()"
                    [disabled]="!CanAddNewMeasure()">
                Sauvegarder<mat-icon>save</mat-icon>
            </button>
        </div>
    </div>
</div>